<template>
  <div class="app-container">
    <div class="app-content">
      <div
        v-loading="queryLoading"
        class="series-home"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-card class="card-container">
          <template slot="header">
            {{ $t('text.dztp') }}
          </template>
          <template slot="default">
            <el-image :src="pramscluster.stationImg" style="width:100%;height:100%;border-radius: 10px;">
              <div slot="error">
                <img src="../../assets/image/station.png" style="width:100%;">
              </div>
            </el-image>
          </template>
        </el-card>
        <el-card class="card-container flow-card">
          <template slot="header">
            {{ $t('text.lct') }}
          </template>
          <template slot="default">
            <div class="card-content">
              <span class="power-text">{{ pramscluster.power | unit('KW') }}</span>
              <span class="capacity-text">{{ pramscluster.capacity | unit('KWp') }}</span>
            </div>
          </template>
        </el-card>
        <el-card class="card-container">
          <template slot="header">
            视频监控
          </template>
          <template slot="default">
            <el-carousel v-if="flag" trigger="click" height="100%">
              <el-carousel-item v-for="(url,index) in urls" :key="index">
                <iframe :src="url" width="100%" height="100%" />
              </el-carousel-item>
            </el-carousel>
            <div v-else style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;color: white;">
              视频源不存在，请检查摄像头是否故障！
            </div>
          </template>
        </el-card>
        <el-card class="card-container energy-saving__card">
          <template slot="header">
            {{ $t('text.jnjpsr') }}
          </template>
          <template slot="default">
            <div class="energy-saving__item">
              <img src="../../assets/icon/co2.png" alt="">
              <div class="text-container">
                <p>{{ $t('text.co2') }}</p>
                <p>{{ pramscluster.safeCO2 | unit('T') }}</p>
              </div>
            </div>
            <div class="energy-saving__item">
              <img src="../../assets/icon/tree.png" alt="">
              <div class="text-container">
                <p>{{ $t('text.dxzsl') }}</p>
                <p>{{ pramscluster.safeTrees | unit($t('text.ks')) }}</p>
              </div>
            </div>
            <div class="energy-saving__item">
              <img src="../../assets/icon/rmb.png" alt="">
              <div class="text-container">
                <p>{{ $t('text.ljsr') }}</p>
                <p>{{ pramscluster.totalIncome | unit($t('text.yuan')) }}</p>
              </div>
            </div>
          </template>
        </el-card>
        <el-card class="card-container power-generation-trends__card" style="grid-column: span 2;">
          <template slot="header">
            {{ $t('text.fdqs') }}
          </template>
          <template slot="default">
            <LineChart
              :data="balance.data"
              :columns="balance.columns"
              :setting="balance.setting"
              :extend="balance.extend"
              :format="balance.format"
              :unit="balance.unit"
              :loading="queryLoading"
            />
          </template>
        </el-card>
        <el-card class="card-container energy-card">
          <template slot="header">
            电量
          </template>
          <template slot="default">
            <div class="energy-item">
              <img src="../../assets/icon/drdl1.png" alt="">
              <div class="text-content">
                <p>{{ $t('text.drdl') }}</p>
                <p>
                  {{ ymdEnergys.dayEnergy | objValue('cvalue',0) }} {{ ymdEnergys.dayEnergy | objValue('cvalue',1) }}
                </p>
              </div>
            </div>
            <div class="energy-item">
              <img src="../../assets/icon/dydl1.png" alt="">
              <div class="text-content">
                <p>{{ $t('text.dydl') }}</p>
                <p>
                  {{ ymdEnergys.monthEnergy | objValue('cvalue',0) }} {{ ymdEnergys.monthEnergy | objValue('cvalue',1) }}
                </p>
              </div>
            </div>
            <div class="energy-item">
              <img src="../../assets/icon/dndl1.png" alt="">
              <div class="text-content">
                <p>{{ $t('text.dndl') }}</p>
                <p>
                  {{ ymdEnergys.yearEnergy | objValue('cvalue',0) }} {{ ymdEnergys.yearEnergy | objValue('cvalue',1) }}
                </p>
              </div>
            </div>
            <div class="energy-item">
              <img src="../../assets/icon/zdl1.png" alt="">
              <div class="text-content">
                <p>{{ $t('text.zdl') }}</p>
                <p>
                  {{ ymdEnergys.totalEnergy | objValue('cvalue',0) }} {{ ymdEnergys.totalEnergy | objValue('cvalue',1) }}
                </p>
              </div>
            </div>
          </template>
        </el-card>
        <el-card class="card-container generated-energy__card">
          <template slot="header">
            <span>发电量</span>
            <div class="operate-container">
              <el-button-group style="margin-right: 10px;display: flex;">
                <el-button
                  :type="dateType === 'day' ? 'primary' : ''"
                  size="small"
                  @click="dateType = 'day';getEneryData()"
                >{{ $t('text.r') }}</el-button>
                <el-button
                  :type="dateType === 'month' ? 'primary' : ''"
                  size="small"
                  @click="dateType = 'month';getEneryData()"
                >{{ $t('text.y') }}</el-button>
                <el-button
                  :type="dateType === 'year' ? 'primary' : ''"
                  size="small"
                  @click="dateType = 'year';getEneryData()"
                >{{ $t('text.n') }}</el-button>
              </el-button-group>
              <el-date-picker
                v-show="dateType === 'day'"
                v-model="queryParams.starttime"
                type="date"
                size="small"
                style="width: 200px !important; margin-top: 0;"
                @change="getEneryData()"
              />
              <el-date-picker
                v-show="dateType === 'month'"
                v-model="queryParams.starttime"
                type="month"
                size="small"
                style="width: 200px !important; margin-top: 0;"
                @change="getEneryData()"
              />
            </div>
          </template>
          <template slot="default">
            <histogam-chart
              :data="chart.data"
              :columns="chart.columns"
              :setting="chart.setting"
              :extend="chart.extend"
              :format="chart.format"
              :unit="chart.unit"
            />
          </template>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import { GetClusterStationOverviewData, GetClusterStationEnergyChartData } from '@/api/Statistics'
import LineChart from '@/components/Charts/LineChart.vue'
import HistogamChart from '@/components/Charts/HistogramChart.vue'
import { getMonthLength } from '@utils'
import { GetYsyPlayUrl } from '@/api/Universal'
import { GetCamerasByStationId } from '@/api/Device'

export default {
  name: 'SeriesHome',
  components: {
    LineChart,
    HistogamChart
  },
  data () {
    return {
      queryLoading: false,
      pramscluster: {},
      queryParams: {
        starttime: this.$parseTime(new Date(), 'yyyy-MM-dd 00:00:00'),
        endtime: this.$parseTime(new Date(), 'yyyy-MM-dd 23:59:59')
      },
      urls: [],
      flag: false,
      ymdEnergys: {},
      dateType: 'day',
      balance: {
        data: [],
        columns: ['time', 'val1'],
        setting: {
          area: true,
          labelMap: { val1: this.$t('text.gl') },
          areaStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: 'rgba(255, 158, 68,1)'
              },
              {
                offset: 1,
                color: 'rgba(240, 145, 68,0.05)'
              }
            ])
          },
        },
        format: ['hh:mm'],
        unit: 'kW',
        extend: {
          textStyle: {
            color: '#fff'
          },
          itemStyle: {
            color: 'rgb(255, 158, 68)'
          },
          grid: {
            right: 30,
            left: 30,
            bottom: '0',
            top: '20%',
          },
          yAxis: {
            name: 'KW',
            position: 'left',
            splitLine: {
              show: true,
              lineStyle: {
                color: '#3845A1'
              }
            },
          },
          legend: {
            textStyle: {
              color: '#fff'
            }
          },
        }
      },
      chart: {
        data: [],
        format: ['yyyy-MM-dd'],
        unit: 'kWh',
        extend: {
          textStyle: {
            color: '#fff'
          },
          barWidth: '30px',
          legend: {
            textStyle: {
              color: '#fff'
            }
          },
          color: ['#F39800'],
          yAxis: {
            name: 'KWh',
            position: 'left',
            splitLine: {
              show: true,
              lineStyle: {
                color: '#3845A1'
              }
            },
          },
          grid: {
            top: '20%',
            left: 30,
            bottom: '0%',
          },
        },
        columns: [],
        setting: {
          labelMap: {
            val1: '电量',
          }
        },
      },
    }
  },
  created () {
    this.getOverviewData().then(() => {
      this.getEneryData().then(() => {
        this.getCameras()
      })
    })
  },
  methods: {
    getCameras () {
      GetCamerasByStationId({
        id: this.$store.getters.station.id
      }).then(res => {
        const responseData = res.data || []
        this.flag = responseData.length > 0
        this.getPlayVideo(responseData)
      }).catch(() => {
        this.queryLoading = false
        this.$message({
          type: 'error',
          message: '获取数据失败'
        })
      })
    },
    getPlayVideo (responseData) {
      if (responseData.length > 0) {
        const promiseArray = []
        this.urls = []
        responseData.forEach(item => {
          const postData = {
            sn: item.gatewaysn,
            ishd: '0'
          }
          promiseArray.push(GetYsyPlayUrl(postData))
        })
        Promise.all(promiseArray).then(response => {
          if (response && response.length > 0) {
            this.urls = response.map(item => item.data)
          }
        })
      }
      this.queryLoading = false
    },
    getOverviewData () {
      this.queryLoading = true
      return new Promise((resolve, reject) => {
        GetClusterStationOverviewData({ id: this.$store.getters.station.id }).then(res => {
          this.pramscluster = res.data
          this.ymdEnergys = res.data.ymdEnergys
          this.balance.data = res.data.powerChartData || []
          resolve(res)
        }).catch(() => {
          this.queryLoading = false
          this.$message({
            type: 'error',
            message: '获取数据失败'
          })
          reject()
        })
      })
    },
    getEneryData () {
      return new Promise((resolve, reject) => {
        let mask1 = ''
        let mask2 = ''
        if (this.dateType === 'day') {
          mask1 = 'yyyy-MM-dd 00:00:00'
          mask2 = 'yyyy-MM-dd 23:59:59'
        } else if (this.dateType === 'month') {
          const l = getMonthLength(this.queryParams.endtime)
          mask1 = 'yyyy-MM-01 00:00:00'
          mask2 = 'yyyy-MM-' + l + ' 23:59:59'
        } else if (this.dateType === 'year') {
          mask1 = 'yyyy-01-01 00:00:00'
          mask2 = 'yyyy-12-31 23:59:59'
        }
        GetClusterStationEnergyChartData({
          dateType: this.dateType,
          startTime: this.$parseTime(this.queryParams.starttime, mask1),
          endTime: this.$parseTime(this.queryParams.endtime, mask2),
          Culture: 'zh-cn',
          Token: '26A24B0812A941ABB793F339393EF535',
          OpenID: 'D43AFC6F548E439BBE5230ED2D6C0692',
          orgId: this.$store.getters.station.id
        }).then((res) => {
          if (res.data) {
            this.chart.data = res.data
            this.chart.columns = ['time', 'val1']
            res.data.map(o => {
              o.time = this.$parseTime(o.time, 'yyyy-MM-dd')
            })
          } else {
            this.chart.data = []
            this.$message({
              type: 'error',
              message: '所选时间段暂无数据'
            })
          }
          resolve(res)
        }).catch(() => {
          this.queryLoading = false
          this.$message({
            type: 'error',
            message: '获取数据失败'
          })
          reject()
        })
      })
    }
  }
}
</script>

<style scoped>
.series-home {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(3,1fr);
  grid-template-rows: repeat(3,1fr);
  grid-gap: 15px;
  background-color: #1C2550;
}

.series-home .card-container{
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}
.series-home .card-container >>> .el-card__header{
  width: 100%;
  height: 40px;
  padding: 0 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  color: white;
}
.series-home .card-container >>> .el-card__header::before{
  display: block;
  content: '';
  width: 5px;
  height: 20px;
  background-color: #1CC197;
  border-radius: 2px;
  margin-right: 10px;
}

.series-home .card-container >>> .el-card__body{
  width: 100%;
  height: calc(100% - 40px);
  padding: 0 15px 10px;
  box-sizing: border-box;
}

.series-home .flow-card >>> .el-card__body .card-content{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background: url("../../assets/lct.png") center center no-repeat;
  background-size: contain;
  position: relative;
}
.series-home .flow-card >>> .el-card__body .card-content .power-text{
  position: absolute;
  color: white;
  font-weight: bold;
  left: 150px;
  bottom: 60px;
}
.series-home .flow-card >>> .el-card__body .card-content .capacity-text{
  position: absolute;
  color: white;
  font-weight: bold;
  right: 200px;
  bottom: 115px;
}

.series-home .energy-saving__card >>> .el-card__body{
   display: grid;
   grid-template-columns: repeat(3,1fr);
   grid-gap: 15px;
}
.series-home .energy-saving__card >>> .el-card__body .energy-saving__item{
    width: 100%;
    height: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    background-color: #162B5E;
    border-radius: 5px;
}
.series-home .energy-saving__card >>> .el-card__body .energy-saving__item .text-container{
  width: 100%;
  color: white;
  font-weight: bold;
  text-align: center;
}
.series-home .energy-saving__card >>> .el-card__body .energy-saving__item .text-container:first-child{
  margin-bottom: 0.5em;
}

.series-home .power-generation-trends__card >>> .el-card__body .v-charts-component-loading{
   background-color: var(--card-bg-color);
}

.series-home .energy-card >>> .el-card__body{
  display:grid;
  grid-template-columns: repeat(2,1fr);
  grid-template-rows: repeat(2,1fr);
}
.series-home .energy-card >>> .el-card__body .energy-item{
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  justify-items: flex-end;
  grid-gap: 10px;
}
.series-home .energy-card >>> .el-card__body .energy-item img{
  width: 40px;
  height: 40px;
}
.series-home .energy-card >>> .el-card__body .energy-item .text-content{
  color: #19D4AE;
  justify-self: flex-start;
  font-size: medium;
  font-weight: bold;
}

.series-home .generated-energy__card{
  grid-column: span 2;
}
.series-home .generated-energy__card >>> .el-card__header .operate-container{
  height: 40px;
  display: flex;
  flex: auto;
  align-items: center;
  justify-content: flex-end;
}
</style>

